/** Optional soft hyphen for inspector/UI labels — decoded to U+00AD in `renderTranslationHtml`. */
export const TRANSLATION_BREAK_MARKER = '&shy;'
